export default __webpack_public_path__ + "static/media/past.6a33fff3.svg";